"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateFullName = getStateFullName;
exports.getStateCode = getStateCode;
exports.getV2States = getV2States;
exports.getV1States = getV1States;
const states = [
    { code: 'AL', display: 'Alabama' },
    { code: 'AK', display: 'Alaska' },
    { code: 'AZ', display: 'Arizona' },
    { code: 'AR', display: 'Arkansas' },
    { code: 'CA', display: 'California' },
    { code: 'CO', display: 'Colorado' },
    { code: 'CT', display: 'Connecticut' },
    { code: 'DE', display: 'Delaware' },
    { code: 'FL', display: 'Florida' },
    { code: 'GA', display: 'Georgia' },
    { code: 'HI', display: 'Hawaii' },
    { code: 'ID', display: 'Idaho' },
    { code: 'IL', display: 'Illinois' },
    { code: 'IN', display: 'Indiana' },
    { code: 'IA', display: 'Iowa' },
    { code: 'KS', display: 'Kansas' },
    { code: 'KY', display: 'Kentucky' },
    { code: 'LA', display: 'Louisiana' },
    { code: 'ME', display: 'Maine' },
    { code: 'MD', display: 'Maryland' },
    { code: 'MA', display: 'Massachusetts' },
    { code: 'MI', display: 'Michigan' },
    { code: 'MN', display: 'Minnesota' },
    { code: 'MS', display: 'Mississippi' },
    { code: 'MO', display: 'Missouri' },
    { code: 'MT', display: 'Montana' },
    { code: 'NE', display: 'Nebraska' },
    { code: 'NV', display: 'Nevada' },
    { code: 'NH', display: 'New Hampshire' },
    { code: 'NJ', display: 'New Jersey' },
    { code: 'NM', display: 'New Mexico' },
    { code: 'NY', display: 'New York' },
    { code: 'NC', display: 'North Carolina' },
    { code: 'ND', display: 'North Dakota' },
    { code: 'OH', display: 'Ohio' },
    { code: 'OK', display: 'Oklahoma' },
    { code: 'OR', display: 'Oregon' },
    { code: 'PA', display: 'Pennsylvania' },
    { code: 'RI', display: 'Rhode Island' },
    { code: 'SC', display: 'South Carolina' },
    { code: 'SD', display: 'South Dakota' },
    { code: 'TN', display: 'Tennessee' },
    { code: 'TX', display: 'Texas' },
    { code: 'UT', display: 'Utah' },
    { code: 'VT', display: 'Vermont' },
    { code: 'VA', display: 'Virginia' },
    { code: 'WA', display: 'Washington' },
    { code: 'WV', display: 'West Virginia' },
    { code: 'WI', display: 'Wisconsin' },
    { code: 'WY', display: 'Wyoming' },
    { code: 'FM', display: 'American Samoa' },
    { code: 'MH', display: 'Marshall Islands' },
    { code: 'MP', display: 'Northern Mariana Islands' },
    { code: 'PW', display: 'Palau' },
];
function getStateFullName(stateCode) {
    return states.find(s => s.code == stateCode)?.display || stateCode;
}
function getStateCode(stateName) {
    return states.find(s => s.display == stateName)?.code || stateName;
}
function getV2States() {
    const isDev = (process.env.NODE_ENV && ['development', 'local'].includes(process.env.NODE_ENV));
    const devOnlyStates = [];
    const v2States = [
        'CA', 'AR', 'CT', 'GA', 'IA', 'IL', 'IN', 'SC',
        'ID', 'KY', 'MT', 'NE', 'NM', 'ND', 'OH', 'MS',
        'OR', 'PA', 'RI', 'WI', 'WY', 'AZ', 'DE', 'MA',
        'ME', 'MO', 'NC', 'NY', 'SD', 'UT', 'WV', 'LA',
        'NH', 'OK', 'WA', 'TN', 'NV', 'VA', 'MI', 'NJ',
        'MD', 'VT', 'MN', 'KS', 'TX', 'CO', 'AL', 'FL'
    ];
    let getV2statesResponse = v2States;
    if (isDev) {
        getV2statesResponse = [...v2States, ...devOnlyStates];
    }
    return getV2statesResponse;
}
function getV1States() {
    const isDev = (process.env.NODE_ENV && ['development', 'local'].includes(process.env.NODE_ENV));
    const devOnlyStates = [];
    const v1States = [
        'AZ', 'AR', 'CA', 'DE',
        'GA', 'IA', 'ID', 'IL', 'IN',
        'KS', 'OH', 'PA', 'ME', 'MI',
        'MO', 'MN', 'NC', 'ND', 'NE',
        'NM', 'NY', 'NV', 'RI', 'SD',
        'SC', 'TN', 'UT', 'VT', 'WI',
        'WV', 'MD', 'KY', 'NH', 'CT',
        'MT', 'CO', 'WY', 'VA'
    ];
    let getV2statesResponse = v1States;
    if (isDev) {
        getV2statesResponse = [...v1States, ...devOnlyStates];
    }
    return getV2statesResponse;
}
